import { apiDate } from '@/platform/lib/utils';
import { Button, Form, FormGroup, Input, Select } from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';
import SidePanel from './SidePanel';

const SroiEntitlementPanel = ({ entitlement, onClose }) => {
    const {
        employee,
        categories,
        pso_categories: psoCategories,
    } = usePage().props;

    const { data, setData, post, patch, processing, errors } = useForm({
        category: entitlement?.category ?? '',
        pso_category: entitlement?.pso_category ?? '',
        start_date: apiDate(entitlement?.start_date) ?? '',
        end_date: apiDate(entitlement?.end_date) ?? '',
    });

    const baseUrl = `/customers/${employee.customer_id}/employees/${employee.id}/sroi`;

    const handleSubmit = event => {
        event.preventDefault();

        const options = {
            reset: ['employee', 'navigation'],
            preserveScroll: true,
            onSuccess: onClose,
        };

        entitlement
            ? patch(`${baseUrl}/${entitlement.id}`, options)
            : post(baseUrl, options);
    };

    return (
        <SidePanel
            title={entitlement ? 'SROI-recht wijzigen' : 'SROI-recht toevoegen'}
            subtitle='Velden met * zijn verplicht.'
            onClose={onClose}
            footer={
                <div className='flex justify-end gap-2'>
                    <Button type='button' onClick={onClose}>
                        Annuleren
                    </Button>
                    <Button
                        type='submit'
                        form='sroi-entitlement'
                        variant='primary'
                        loading={processing}
                    >
                        {entitlement ? 'Wijzigingen opslaan' : 'Toevoegen'}
                    </Button>
                </div>
            }
        >
            <Form id='sroi-entitlement' onSubmit={handleSubmit}>
                <FormGroup>
                    <Select
                        label='Categorie'
                        description='De doelgroep waarop dit recht is gebaseerd.'
                        placeholder='Kies een categorie'
                        required
                        value={data.category}
                        onChange={event =>
                            setData('category', event.target.value)
                        }
                        options={categories}
                        error={errors.category}
                    />
                    <Select
                        label='PSO-categorie'
                        description='Bepaalt hoe deze werknemer meetelt op de PSO-prestatieladder.'
                        value={data.pso_category}
                        onChange={event =>
                            setData('pso_category', event.target.value)
                        }
                        options={[
                            { id: '', name: 'Geen categorie' },
                            ...psoCategories,
                        ]}
                        error={errors.pso_category}
                    />
                    <Input
                        type='date'
                        label='Startdatum'
                        required
                        value={data.start_date}
                        onChange={event =>
                            setData('start_date', event.target.value)
                        }
                        error={errors.start_date}
                    />
                    <Input
                        type='date'
                        label='Einddatum'
                        description='Laat leeg als het recht doorloopt.'
                        value={data.end_date}
                        onChange={event =>
                            setData('end_date', event.target.value)
                        }
                        error={errors.end_date}
                    />
                </FormGroup>
            </Form>
        </SidePanel>
    );
};

export default SroiEntitlementPanel;
